<template>
    <div class="container">
        <md-dialog :md-active.sync="modDetReport" :md-click-outside-to-close="false">
            <!-- <pre>{{ infoDet }}</pre> -->
            <md-dialog-title class="text-center">
                {{ labels.title }} {{infoDet[0].nro_contrato}}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <md-table md-card md-header v-model="infoDet">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell :md-label="labels.fecha" class="border">{{ item.fecha_cierre }}</md-table-cell>
                            <md-table-cell :md-label="labels.actDerechUso" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.activo_derecho_uso_bruto) }}</md-table-cell>
                            <md-table-cell :md-label="labels.amortAcumulada" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.amortizacion_acumulada) }}</md-table-cell>
                            <md-table-cell :md-label="labels.pasivoFinal" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.pasivo_final) }}</md-table-cell>
                            <md-table-cell :md-label="labels.patrimoNeto" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.patrimonio_neto) }}</md-table-cell>
                            <md-table-cell :md-label="labels.pasivoInic" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.pasivo_inicial) }}</md-table-cell>
                            <md-table-cell :md-label="labels.pagoCapital" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.pago_capital) }}</md-table-cell>
                            <md-table-cell :md-label="labels.gastPorAmortiza" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.gasto_por_amortizacion) }}</md-table-cell>
                            <md-table-cell :md-label="labels.gastPorIntereses" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.gasto_por_intereses) }}</md-table-cell>
                            <md-table-cell :md-label="labels.gastPorArrendami" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.gasto_por_arrendamiento) }}</md-table-cell>
                            <md-table-cell :md-label="labels.utilidadAcumulad" class="border">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.utilidades_acumuladas) }}</md-table-cell>
                        </md-table-row>
                    </md-table>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
export default {
    name : 'ModDetalleReporte',
    props : ['modDetReport','infoDet'],
    data : () => ({

    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Contrato',
                    close : 'Cerrar',
                    fecha : 'Fecha',
                    actDerechUso : 'Activo derecho uso',
                    amortAcumulada : 'Amortización acumulada',
                    pasivoFinal : 'Pasivo final',
                    patrimoNeto : 'Patrimonio neto',
                    pasivoInic : 'Pasivo inicial',
                    pagoCapital : 'Pago capital',
                    gastPorAmortiza : 'Gasto por amortización',
                    gastPorIntereses : 'Gasto por intereses',
                    gastPorArrendami : 'Gasto por arrendamiento',
                    utilidadAcumulad : 'Utilidades acumuladas'
                }
            }else{
                return {
                    title : 'Contract',
                    close : 'Close',
                    fecha : 'Date',
                    actDerechUso : 'Asset right use',
                    amortAcumulada : 'Accumulated amortization',
                    pasivoFinal : 'Final passive',
                    patrimoNeto : 'Net worth',
                    pasivoInic : 'Initial liabilities',
                    pagoCapital : 'Capital payment',
                    gastPorAmortiza : 'Amortization expense',
                    gastPorIntereses : 'Interest expense',
                    gastPorArrendami : 'Lease expense',
                    utilidadAcumulad : 'Retained earnings'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
    }
}
</script>

<style>

</style>